/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { LocationUrls } from "./LocationUrls";

/**
 * Routes whose screens present the video player in their UI and therefore claim
 * a visible PlayerViewMode on mount:
 *
 *   - /player → FullScreenPlayback  (PlayerViewMode.FullScreen)
 *   - /guide  → GuideScreen         (PlayerViewMode.PIG)
 *
 * Every other route has no player surface, so navigating to it puts the player
 * into PlayerViewMode.Hidden (paused + invisible, media source retained).
 *
 * Maintained as an allowlist rather than a list of playerless screens so that
 * new screens get the safe Hidden behaviour by default — a screen only opts out
 * by adding itself here and claiming a view mode on mount.
 */
const PLAYER_HOSTING_URLS: ReadonlySet<string> = new Set<string>([
  LocationUrls.PLAYER,
  LocationUrls.GUIDE,
  LocationUrls.HOME_SCREEN
]);

/**
 * Returns whether the given route renders the video player in its UI.
 *
 * @param url - An absolute pathname such as "/player" or "/my-hub".
 */
export function isPlayerHostingUrl(url: string): boolean {
  return PLAYER_HOSTING_URLS.has(url);
}
